export const getJobTypeName = (
  jobTypeName: string | null | undefined,
  managementJobTypeName: string | null | undefined
) => {
  return jobTypeName && managementJobTypeName
    ? `${jobTypeName} & ${managementJobTypeName}`
    : `${jobTypeName ?? ''}${managementJobTypeName ?? ''}`;
};
